import request from '@/utils/request'
const BASE_URL = '/SkCostBook'

//系统
export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  ///SkCostBook/ReCalPrice
  save(data) {
    return request({
      url: BASE_URL + '/ReCalPrice',
      method: 'post',
      data
    })
  },
}